import React from 'react'
import { NotificationsConfirm } from 'gu-ui-kit'
import clsx from 'clsx'
import styles from 'modules/Forms/Account/Create/account-form-creation.module.scss'
import formatMoney from 'utils/formatMoney'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const ProviderNotification = ({ currentProvider }) => {
  const { t } = useTranslation()

  return (
    <NotificationsConfirm
      className={clsx(styles['provider-notification'], 'margin-bottom-16')}
      variant={'neutral'}
      title={t('services::forms.shared_fields.provider_id.notification.title')}
      CloseButton={null}
      description={
        <>
          {currentProvider?.promo_text && (
            <div
              dangerouslySetInnerHTML={{ __html: currentProvider.promo_text }}
            />
          )}

          <ul>
            <li
              dangerouslySetInnerHTML={{
                __html: t(
                  'services::forms.shared_fields.provider_id.notification.description',
                  {
                    context: 'setup_fee',
                    setup_fee: formatMoney(
                      currentProvider?.setup_fee,
                      currentProvider?.currency,
                    ),
                  },
                ),
              }}
            />
            <li
              dangerouslySetInnerHTML={{
                __html: t(
                  'services::forms.shared_fields.provider_id.notification.description',
                  {
                    context: 'min_amount',
                    min_amount: formatMoney(
                      currentProvider?.min_amount,
                      currentProvider?.currency,
                    ),
                  },
                ),
              }}
            />
            <li
              dangerouslySetInnerHTML={{
                __html: t(
                  'services::forms.shared_fields.provider_id.notification.description',
                  {
                    context: 'duration',
                    external_account_creation_duration_business_days:
                      currentProvider?.external_account_creation_duration_business_days,
                  },
                ),
              }}
            />
          </ul>
        </>
      }
    />
  )
}

export default ProviderNotification

ProviderNotification.propTypes = {
  currentProvider: PropTypes.object,
}
